import { z } from 'zod';

export const AppEnvSchema = z.object({
  DATABASE_URL:         z.url(),
  MORPH_API_KEY:        z.string().min(1),
  BENICE_BASE_URL:      z.url(),
  BENICE_SERVICE_TOKEN: z.string().min(1),
  RESEND_API_KEY:       z.string().min(1),
  NEXTAUTH_SECRET:      z.string().min(32),
  NEXTAUTH_URL:         z.url(),
  INNGEST_EVENT_KEY:    z.string().min(1),
  INNGEST_SIGNING_KEY:  z.string().min(1),
  LANGFUSE_PUBLIC_KEY:  z.string().min(1),
  LANGFUSE_SECRET_KEY:  z.string().min(1),
  LANGFUSE_BASE_URL:    z.url(),
  DEEPSEEK_API_KEY:     z.string().min(1),
  DEEPSEEK_BASE_URL:    z.url(),
  DEEPSEEK_MODEL_CHAT:  z.string().min(1).default('deepseek-v4-flash'),
  DEEPSEEK_MODEL_REASONER: z.string().min(1).default('deepseek-v4-pro'),
  GEMINI_API_KEY:       z.string().min(1).optional(),
  GEMINI_MODEL:         z.string().min(1).default('gemini-2.5-flash'),
  NODE_ENV:             z.enum(['development', 'test', 'production']).default('development'),
  PORT:                 z.coerce.number().int().positive().default(3000),
});

export type AppEnv = z.infer<typeof AppEnvSchema>;

export function parseAppEnv(input: Record<string, string | undefined>): AppEnv {
  const result = AppEnvSchema.safeParse(input);
  if (!result.success) {
    const issues = result.error.issues.map(i => `${i.path.join('.')}: ${i.message}`).join('; ');
    throw new Error(`AppEnv validation failed: ${issues}`);
  }
  return result.data;
}
